import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5cbed731"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "header-container" };
const _hoisted_2 = { class: "flex-x" };
const _hoisted_3 = { class: "flex-x margin-left-small" };
const _hoisted_4 = { alt: "live button" };
const _hoisted_5 = { class: "align-right flex-center gap-small desktop" };
const _hoisted_6 = _withScopeId(() => _createElementVNode("img", {
    class: "header-action-img",
    src: "svg/account.svg",
    alt: "account icon"
}, null, -1));
const _hoisted_7 = _withScopeId(() => _createElementVNode("p", { class: "noselect" }, "Account", -1));
const _hoisted_8 = [
    _hoisted_6,
    _hoisted_7
];
const _hoisted_9 = _withScopeId(() => _createElementVNode("img", {
    class: "header-action-img",
    src: "svg/info.svg",
    alt: "info icon"
}, null, -1));
const _hoisted_10 = _withScopeId(() => _createElementVNode("p", { class: "noselect" }, "Info", -1));
const _hoisted_11 = [
    _hoisted_9,
    _hoisted_10
];
const _hoisted_12 = { class: "align-right flex-center gap-med mobile" };
const _hoisted_13 = _withScopeId(() => _createElementVNode("img", {
    class: "header-action-mobile-img",
    src: "svg/account.svg",
    alt: "account icon"
}, null, -1));
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = _withScopeId(() => _createElementVNode("img", {
    class: "header-action-mobile-img",
    src: "svg/info.svg",
    alt: "account icon"
}, null, -1));
const _hoisted_16 = [
    _hoisted_15
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", {
                id: "header-title",
                class: "noselect clickable",
                onClick: _cache[0] || (_cache[0] =
                    (...args) => (_ctx.onReload && _ctx.onReload(...args)))
            }, " InfiniteX "),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", _hoisted_4, [
                    _createElementVNode("p", {
                        class: "header-page-item",
                        onClick: _cache[1] || (_cache[1] =
                            (...args) => (_ctx.onClickLive && _ctx.onClickLive(...args)))
                    }, "Live")
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
                class: "header-action-container",
                onClick: _cache[2] || (_cache[2] =
                    (...args) => (_ctx.onAccount && _ctx.onAccount(...args))),
                alt: "account button"
            }, _hoisted_8),
            _createElementVNode("button", {
                class: "header-action-container",
                onClick: _cache[3] || (_cache[3] =
                    (...args) => (_ctx.onInfo && _ctx.onInfo(...args))),
                alt: "info button"
            }, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
                class: "flex-center clickable full-height",
                onClick: _cache[4] || (_cache[4] =
                    (...args) => (_ctx.onAccount && _ctx.onAccount(...args)))
            }, _hoisted_14),
            _createElementVNode("div", {
                class: "flex-center clickable full-height",
                onClick: _cache[5] || (_cache[5] =
                    (...args) => (_ctx.onInfo && _ctx.onInfo(...args)))
            }, _hoisted_16)
        ])
    ]));
}
